import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import DatosFiscalesReceptorFactura from './DatosFiscalesReceptorFactura';
import PreferenciasFacturacion from './PreferenciasFacturacion';
import PagosOrden from './PagosOrden';
import CfdiRelacionados from './CfdiRelacionados';
import ProductosContainer from './detalles-productos/ProductosContainer';

import { useToast } from 'context/providers/ToastProvider';

import ModalErrorTimbrado from './ModalErrorTimbrado';
import { ContabilidadLayout } from 'akasia-components/Contabilidad/common/ContabilidadLayout';
import { ContabilidadContext } from 'akasia-components/Contabilidad/common/ContabilidadContext';
import { useContext } from 'react';

const FormularioFacturaContent = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const pagoToInvoice = location.state?.pago;

    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { selectedCompany } = useContext(ContabilidadContext);

    // Estados para el modal de error de timbrado
    const [showModalErrorTimbrado, setShowModalErrorTimbrado] = useState(false);
    const [errorTimbradoMensaje, setErrorTimbradoMensaje] = useState('');
    const [errorTimbradoCodigo, setErrorTimbradoCodigo] = useState(null);

    //estado para cuando se envia a timbrar
    const [facturandoTimbrando, setFacturandoTimbrando] = useState(false);

    const [obteniendoDetallesOrden, setObteniendoDetallesOrden] = useState(false);
    const [detallesCargados, setDetallesCargados] = useState(false);
    const [cargandoSaldo, setCargandoSaldo] = useState(false);


    const [idEmisorSeleccionado, setIdEmisorSeleccionado] = useState("");
    const [saldoTimbres, setSaldoTimbres] = useState(null);


    const [RFCSeleccionado, setRFCSeleccionado] = useState("");

    useEffect(() => {
        if (selectedCompany) {
            setIdEmisorSeleccionado(selectedCompany.idDatoFiscal || "");
            setRFCSeleccionado(selectedCompany.vRFC || "");
        }
    }, [selectedCompany]);
    const [formData, setFormData] = useState({
        vRazonSocial: "",
        vRFC: "",
        vCP: "",
        vEmail: "",
        vFolio: "",
        vNumRT: "",
        vCodigoUso: "",
        vClavePago: "",
        vCodigoRegimen: "",
        vMoneda: "",
        dTipoCambio: 1,
        vPaisFacturacion: "",
        vTipoDocumento: "",
        vSerie: "",
        idMetodoPago: "",
        vCondiciones: "",
        dFechaEmision: null,
        cfdiRelacionados: {
            TipoRelacion: "",
            UUIDs: null
        },
        informacionGlobal: {
            Periodicidad: "",
            Meses: "",
            Anio: ""
        }
    });

    const handleChange = (field, value) => {
        setFormData(prev => {
            // Handle nested fields like "cfdiRelacionados.TipoRelacion"
            if (field.includes('.')) {
                const parts = field.split('.');
                if (parts.length === 2) {
                    return {
                        ...prev,
                        [parts[0]]: {
                            ...prev[parts[0]],
                            [parts[1]]: value
                        }
                    };
                }
            }
            return { ...prev, [field]: value };
        });
    };

    /**
    * Obtiene el saldo de timbres disponibles desde Prodigia
    */
    const ObtenerSaldoTimbres = async () => {
        setCargandoSaldo(true);

        try {
            const response = await fetch("/api/contabilidad/facturas/FormularioFactura/ObtenerSaldoTimbres", {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();

                if (data.iResponseType === 1) {
                    setSaldoTimbres(data.saldo);
                } else {
                    console.warn("No se pudo obtener el saldo de timbres:", data.vMessage);
                    setSaldoTimbres(null);
                    showErrorToast(data.vMessage || "No se pudo obtener el saldo de timbres");
                }
            } else {
                console.error("Error al obtener saldo de timbres:", response.status);
                setSaldoTimbres(null);

                try {
                    const errorData = await response.json();
                    showErrorToast(errorData.vMessage || `Error al obtener saldo de timbres: ${response.status}`);
                } catch (e) {
                    showErrorToast(`Error al obtener saldo de timbres: ${response.status}`);
                }

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            console.error("Error en la petición de saldo de timbres:", error);
            setSaldoTimbres(null);
            showErrorToast('Error en la petición de saldo de timbres: ' + error.message);
        } finally {
            setCargandoSaldo(false);
        }
    }


    const [isForeignRFC, setIsForeignRFC] = useState(false);


    const now = new Date();
    const minDate = new Date(now.getTime() - 70 * 60 * 60 * 1000);
    const [productosAgregados, setProductosAgregados] = useState([]);
    const [ordenDetallesProductos, setOrdenDetallesProductos] = useState([]);
    const [errors, setErrors] = useState({})
    const [incluirCfdiRelacionados, setIncluirCfdiRelacionados] = useState(false);


    useEffect(() => {

        validacionPreviaObtencionDetallesOrden();
        ObtenerSaldoTimbres(); // Obtener saldo al cargar el componente
    }, []);


    /**
     * Validar campos para generar folio
     */
    const validacionPreviaObtencionDetallesOrden = () => {
        // Reiniciar bandera
        setDetallesCargados(false);
        if (id) {
            ObtenerDetallesOrden(id);
            setDetallesCargados(true);
        }
    }


    /**
     * Cambios de RFC
     */
    const handleRFCChange = (rfc) => {
        rfc = rfc.toUpperCase().trim();

        handleChange("vRFC", rfc);

        // Lógica para RFC Genérico y Extranjero
        const isGenericRFC = rfc === "XAXX010101000";
        const isForeignRFC = rfc === "XEXX010101000";

        if (isGenericRFC || isForeignRFC) {
            handleChange("vCodigoUso", "S01");
            handleChange("vCodigoRegimen", "616");
            handleChange("vCP", "");

            setIsForeignRFC(isForeignRFC);
            handleChange("vPaisFacturacion", isForeignRFC ? "" : null);
            handleChange("vNumRT", isForeignRFC ? "" : null);

        } else {
            setIsForeignRFC(false);
            handleChange("vPaisFacturacion", "");
            handleChange("vNumRT", "");
        }
    }


    /**
     * Limpia Errores 
     */
    const clearError = (fieldName) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[fieldName];
            return newErrors;
        });
    }





    //Obtiene las licencias por id
    const ObtenerDetallesOrden = async (idOrden) => {
        setObteniendoDetallesOrden(true)
        var objDataSend = {};

        objDataSend.idOrden = idOrden;

        var jDataSend = JSON.stringify(objDataSend);


        const response = await fetch("/api/contabilidad/facturas/FormularioFactura/ObtenerDetalleOrden", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {

                showErrorToast('' + error.message);


                //console.log('Hubo un problema con la peticion Fetch:' + error.message);

            });

        if (response.ok) {
            const data = await response.json();
            //console.log("========== DETALLES DE ORDEN ==========");
            //console.log("data ORDEN: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                //console.log("ObjDetallesTM:", ObjDetalles);

                //se obtiene los detalles de la orden (HEADER)
                const detalles = ObjDetalles.table2[0];

                // Asignar valores a cada campo usando handleChange
                handleChange('vRazonSocial', detalles.vRazonSocial || '');
                if (detalles.vRfc) {
                    handleRFCChange(detalles.vRfc);
                } else {
                    handleChange('vRFC', '');
                }
                handleChange('vCP', detalles.vCp || '');
                handleChange('vEmail', detalles.vEmailFacturacion || '');
                handleChange('vNumRT', detalles.vNumRegTrib || '');
                
                if (pagoToInvoice) {
                    const pagoForma = pagoToInvoice.vClave || '';
                    if (pagoForma) handleChange('vClavePago', String(pagoForma));
                    else handleChange('vClavePago', detalles.vClavePago || '');
                } else {
                    handleChange('vClavePago', detalles.vClavePago || '');
                }

                handleChange('vCodigoUso', detalles.vCodigoUso || '');
                handleChange('vCodigoRegimen', detalles.vCodigoRegimen || '');

                if (pagoToInvoice) {
                    const pagoMoneda = pagoToInvoice.vMoneda || pagoToInvoice.vMonedaPago || 'MXN';
                    handleChange('vMoneda', pagoMoneda);
                } else {
                    handleChange('vMoneda', detalles.vMoneda || 'MXN');
                }

                handleChange('vPaisFacturacion', detalles.vPaisFacturacion || '');

                // Establecer Tipo de Documento como "Ingreso" por defecto
                handleChange('vTipoDocumento', 'Ingreso');

                // Determinar la serie según la forma de pago
                let serieSeleccionada = ''; // Serie por defecto (Banco)

                if (detalles.vClavePago === "99") {
                    // Si la forma de pago es 99 (Por definir), usar serie CRE
                    serieSeleccionada = 'CRE';
                    handleChange('idMetodoPago', pagoToInvoice ? "PUE" : "PPD");
                } else {
                    // Para otras formas de pago, usar serie BB (Banco)
                    handleChange('idMetodoPago', "PUE");
                }

                // Establecer la serie
                handleChange('vSerie', serieSeleccionada);

                if (pagoToInvoice) {
                    const totalPago = pagoToInvoice.dImportePago ? Number(pagoToInvoice.dImportePago) : 0;
                    const taxRate = 0.16; 
                    let baseImporte = 0;
                    let iva = 0;
                    if (totalPago > 0) {
                        baseImporte = +(totalPago / (1 + taxRate)).toFixed(6);
                        iva = +(totalPago - baseImporte).toFixed(6);
                    }
                    const defaultTotal = +(baseImporte + iva).toFixed(6);
                    
                    setOrdenDetallesProductos([{
                        vCodigoProductoServicioSat: '43232611',
                        vNombreProducto: 'Software de puntos de venta pos (Programa punto de venta POS)',
                        dCantidad: 1,
                        vClaveUnidadSat: 'E48',
                        dPrecioUnitario: parseFloat(baseImporte.toFixed(6)),
                        dImporte: parseFloat(baseImporte.toFixed(6)),
                        dDescuento: 0,
                        vCodigoBarras: 'SERVICIO',
                        dTasaCuotaIVA: taxRate,
                        vTipoFactorIVA: 'Tasa',
                        dIVA: parseFloat(iva.toFixed(6)),
                        dTotal: parseFloat(defaultTotal.toFixed(6))
                    }]);
                } else {
                    setOrdenDetallesProductos(ObjDetalles.table3);
                }

                setObteniendoDetallesOrden(false);

            } else {

                showErrorToast(data.vMessage);
                setObteniendoDetallesOrden(false);
            }

        }
        else {
            setObteniendoDetallesOrden(false)
            showErrorToast(response.status + ' ' + response.statusText);


            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            //console.log(response);
        }

    }


    const validarDatosFactura = (data) => {
        let newErrors = {};

        // Validar emisor seleccionado
        if (!idEmisorSeleccionado) {
            newErrors.idEmisor = "Debe seleccionar un Emisor";
        }

        // Lista de campos obligatorios with su mensaje de error
        const camposObligatorios = [
            { key: 'vClavePago', mensaje: 'El campo Forma de Pago es requerido' },
            { key: 'vCodigoRegimen', mensaje: 'El campo Régimen Fiscal es requerido' },
            { key: 'vCodigoUso', mensaje: 'El campo Uso CFDI es requerido' },
            { key: 'vMoneda', mensaje: 'El campo Moneda es requerido' },
            { key: 'vFolio', mensaje: 'El campo Folio es requerido' },
            { key: 'vRFC', mensaje: 'El campo RFC es requerido' },
            { key: 'vRazonSocial', mensaje: 'El campo Razón Social es requerido' },
            { key: 'vSerie', mensaje: 'El campo Serie es requerido' },
            { key: 'vTipoDocumento', mensaje: 'El campo Tipo de Documento es requerido' },
            { key: 'idMetodoPago', mensaje: 'El campo Método de Pago es requerido' },
        ];

        const rfcValue = data.vRFC?.toUpperCase().trim() || "";
        const isGenericRFC = rfcValue === "XAXX010101000";

        if (!isGenericRFC && !isForeignRFC) {
            camposObligatorios.push({ key: 'vCP', mensaje: 'El campo Código Postal es requerido' });
        }

        // Verificar campos obligatorios
        camposObligatorios.forEach(({ key, mensaje }) => {
            if (!data[key]) {
                newErrors[key] = mensaje;
            }
        });

        // Validar tipo de cambio solo si la moneda NO es MXN
        if (data.vMoneda && data.vMoneda !== "MXN") {
            if (!data.dTipoCambio || data.dTipoCambio <= 0) {
                newErrors.dTipoCambio = "El tipo de cambio es obligatorio para monedas distintas a MXN";
            }
        }

        // Validaciones adicionales si es un RFC extranjero
        if (isForeignRFC) {
            if (!data.vPaisFacturacion) {
                newErrors.vPaisFacturacion = "El campo País es requerido";
            }
        }

        // Validación CFDI Relacionados
        if (incluirCfdiRelacionados) {
            if (!data.cfdiRelacionados?.TipoRelacion) {
                newErrors['cfdiRelacionados.TipoRelacion'] = "Debe seleccionar un Tipo de Relación para el CFDI Relacionado";
            }
            if (!data.cfdiRelacionados?.UUIDs || data.cfdiRelacionados.UUIDs.length === 0) {
                newErrors['cfdiRelacionados.UUIDs'] = "Debe agregar al menos un Folio Fiscal (UUID)";
            }
        }

        // Validación específica para RFC
        if (data.vRFC && !/^[A-Z&]{3,4}\d{6}(?:[A-Z\d]{3})?$/.test(data.vRFC.toUpperCase())) {
            newErrors.vRFC = "El RFC no tiene un formato válido";
        }

        // Validación específica para Folio
        if (data.vFolio && !/^\d+$/.test(data.vFolio)) {
            newErrors.vFolio = "El folio solo puede contener números";
        }

        // Validación específica para Código Postal (vCP)
        if (data.vCP && !/^\d{5}$/.test(data.vCP)) {
            newErrors.vCP = "El código postal debe tener 5 dígitos numéricos";
        }

        // Validación del email
        if (data.vEmail && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(data.vEmail)) {
            newErrors.vEmail = "Formato de correo no válido";
        }

        // Validación del teléfono
        if (data.vTelefono && !/^\+?[0-9]{7,15}$/.test(data.vTelefono)) {
            newErrors.vTelefono = "Formato de teléfono no válido. Ejemplo: +521234567890";
        }

        // Validación Información Global (CFDI 4.0)
        if (data.vRFC === "XAXX010101000" && data.vRazonSocial === "PUBLICO EN GENERAL") {
            if (!data.informacionGlobal?.Periodicidad) {
                newErrors['informacionGlobal.Periodicidad'] = "La periodicidad es requerida";
            }
            if (!data.informacionGlobal?.Meses) {
                newErrors['informacionGlobal.Meses'] = "El mes es requerido";
            }
            if (!data.informacionGlobal?.Anio) {
                newErrors['informacionGlobal.Anio'] = "El año es requerido";
            }
        }

        return newErrors;
    }


    const handleSubmit = (e) => {
        e.preventDefault();

        // Usamos formData que contiene todos los campos unificados
        const data = { ...formData };

        // Si es RFC extranjero, asegurar que vPais esté incluido
        if (isForeignRFC && formData.vPaisFacturacion) {
            data.vPaisFacturacion = formData.vPaisFacturacion;
        }

        // Validar antes de enviar
        const errores = validarDatosFactura(data);
        if (Object.keys(errores).length > 0) {
            setErrors(errores); // Establece los errores en el estado

            // Mostrar Toast si faltan datos de CFDI Relacionados
            if (errores['cfdiRelacionados.UUIDs']) {
                showErrorToast(errores['cfdiRelacionados.UUIDs']);
            } else if (errores['cfdiRelacionados.TipoRelacion']) {
                showErrorToast(errores['cfdiRelacionados.TipoRelacion']);
            }

            // Mostrar Toast si faltan datos de Información Global
            if (errores['informacionGlobal.Periodicidad']) {
                showErrorToast(errores['informacionGlobal.Periodicidad']);
            } else if (errores['informacionGlobal.Meses']) {
                showErrorToast(errores['informacionGlobal.Meses']);
            } else if (errores['informacionGlobal.Anio']) {
                showErrorToast(errores['informacionGlobal.Anio']);
            }

            return; // Detiene la ejecución si hay errores
        }

        // Limpiar informacionGlobal si NO es factura global para no enviarla al backend
        if (!(data.vRFC === "XAXX010101000" && data.vRazonSocial === "PUBLICO EN GENERAL")) {
            delete data.informacionGlobal;
        }

        // Si no hay errores, procede con el registro
        registrarFactura(data);
    }

    /**
    * Registrar factura y redirigir automáticamente a visualización
    */
    const registrarFactura = async (data) => {

        //console.log("data",data)


        // Si dFechaEmision no está definido, usar el date actual formateado
        if (!data.dFechaEmision) {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");
            data.dFechaEmision = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }

        // Agregar el ID del emisor seleccionado
        data.idEmisor = idEmisorSeleccionado;

        if (pagoToInvoice) {
            data.idPago = parseInt(pagoToInvoice.idPago, 10);
            data.bActivarComprobacionUnicoPago = 0;
            const pagoTipoCambio = pagoToInvoice.dTipoCambio || pagoToInvoice.tipoCambio || pagoToInvoice.dTipoCambioPago;
            if (pagoTipoCambio) data.dTipoCambio = Number(pagoTipoCambio);
        } else {
            data.bActivarComprobacionUnicoPago = 1;
        }

        // Limpiar los productos para enviar solo la información necesaria al backend 
        // y truncar decimales a un máximo de 6 como requiere el SAT
        const redondearSeisDecimales = (valor) => {
            if (valor == null || isNaN(valor)) return valor;
            return Number(Number(valor).toFixed(6));
        };

        const productosProcesados = productosAgregados.map(prod => {
            const productoLimpio = { ...prod };
            delete productoLimpio.imagenURL;

            return {
                ...productoLimpio,
                dPrecioUnitario: redondearSeisDecimales(productoLimpio.dPrecioUnitario),
                dCantidad: redondearSeisDecimales(productoLimpio.dCantidad),
                dImporte: redondearSeisDecimales(productoLimpio.dImporte),
                dTotalTraslados: redondearSeisDecimales(productoLimpio.dTotalTraslados),
                dTotalRetenciones: redondearSeisDecimales(productoLimpio.dTotalRetenciones),
                dTotal: redondearSeisDecimales(productoLimpio.dTotal),
                impuestos: (productoLimpio.impuestos || []).map(imp => ({
                    ...imp,
                    tasaCuota: redondearSeisDecimales(imp.tasaCuota),
                    importe: redondearSeisDecimales(imp.importe)
                }))
            };
        });

        data.productosAgregados = productosProcesados;

        // Agregar el ID de la orden si existe, de lo contrario enviar 0
        if (id && id !== ":id" && !isNaN(parseInt(id))) {
            data.idOrden = parseInt(id);
        } else {
            data.idOrden = 0;
        }

        setFacturandoTimbrando(true)

        //console.log("Data parameter(registrarFactura) ", data)

        try {
            const response = await fetch("/api/contabilidad/Facturacion/registrarFactura",
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

            if (response.ok) {
                setFacturandoTimbrando(false);

                const responseData = await response.json();

                if (responseData.iResponseType === 1) {
                    // Factura generada e importada exitosamente

                    showSuccessToast('Factura generada e importada exitosamente');

                    // Usar directamente el redirectUrl si existe
                    if (responseData.redirectUrl) {
                        navigate(responseData.redirectUrl);

                    }
                    // Si no existe redirectUrl, intentar construir desde idFactura
                    else if (responseData.idFactura) {
                        const idFactura = responseData.idFactura;
                        navigate(`/contabilidad/centro-xml/facturas-emitidas/visualizacion/${idFactura}`);

                    } else {
                        // Si no se pudo obtener el ID, solo mostrar mensaje de éxito
                        console.warn("No se pudo obtener el ID de la factura para redireccionar");
                    }
                } else {
                    // Error en la importación

                    showErrorToast(responseData.vMessage || "Error al procesar la factura");
                }

            } else {
                setFacturandoTimbrando(false);

                // Intentar parsear la respuesta JSON de error
                try {
                    const errorData = await response.json();

                    // Detectar si es un error de timbrado usando el flag o el contenido del mensaje
                    const esTimbradoError = errorData.esTimbradoError ||
                        (errorData.vMessage &&
                            (errorData.vMessage.includes('Error al timbrar') ||
                                errorData.vMessage.includes('timbrado') ||
                                errorData.vMessage.includes('Prodigia')));

                    if (esTimbradoError) {
                        // Mostrar modal de error de timbrado
                        setErrorTimbradoMensaje(errorData.vMessage);
                        setErrorTimbradoCodigo(errorData.codigo || null);
                        setShowModalErrorTimbrado(true);
                    } else if (errorData.errores && Array.isArray(errorData.errores)) {
                        // Mostrar errores de validación en el mensaje de error normal
                        const mensajeErrores = errorData.errores.join('\n• ');

                        showErrorToast(`Errores de validación:\n• ${mensajeErrores}`);
                    } else {
                        // Otro tipo de error

                        showErrorToast(errorData.vMessage || `Error al procesar la factura: ${response.status}`);
                    }
                } catch (parseError) {
                    // Si no es JSON, mostrar el texto plano
                    const errorText = await response.text();

                    showErrorToast(`Error al procesar la factura: ${response.status} ${errorText}`);
                }

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            setFacturandoTimbrando(false);

            showErrorToast('Hubo un problema con la peticion: ' + error.message);
            //console.log('Hubo un problema con la peticion:', error);
        }
    };


    /**
     * Fecha valores e icono 
     */
    const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control
                size="sm"
                ref={ref}
                onClick={onClick}
                value={value || ""} // Si value es null o undefined, muestra una cadena vacía
                placeholder="Seleccione una fecha" // Muestra el texto cuando no hay valor
                className="ps-4"
                readOnly // Evita edición manual del campo
            />
            <FontAwesomeIcon
                icon="calendar-alt"
                className="text-primary position-absolute top-50 translate-middle-y ms-2"
            />
        </div>
    ));

    GreetingsDateInput.propTypes = {
        value: PropTypes.string,
        onClick: PropTypes.func,
    };



    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center justify-content-between">
                    <Col xs="auto">
                        <IconButton
                            onClick={() => navigate(-1)}
                            variant="falcon-default"
                            size="sm"
                            icon="arrow-left"
                        />
                    </Col>
                    <Col xs="auto" className="text-end">
                        {/* Indicador de saldo de timbres */}
                        {cargandoSaldo ? (
                            <div className="d-flex align-items-center">
                                <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                <span className="text-muted small">Consultando timbres...</span>
                            </div>
                        ) : saldoTimbres !== null ? (
                            <div className="d-flex align-items-center">
                                <FontAwesomeIcon
                                    icon="receipt"
                                    className={`me-2 ${saldoTimbres > 30000 ? 'text-success' : saldoTimbres > 20000 ? 'text-warning' : 'text-danger'}`}
                                />
                                <div className="d-flex flex-column align-items-start">
                                    <span className="small text-muted">Timbres disponibles</span>
                                    <span className={`fw-bold ${saldoTimbres > 30000 ? 'text-success' : saldoTimbres > 20000 ? 'text-warning' : 'text-danger'}`}>
                                        {saldoTimbres.toLocaleString()}
                                    </span>
                                </div>
                                <Button
                                    onClick={ObtenerSaldoTimbres}
                                    variant="falcon-default"
                                    size="sm"
                                    className="ms-2"
                                    title="Actualizar saldo"
                                >
                                    <FontAwesomeIcon icon="sync" />
                                </Button>
                            </div>
                        ) : (
                            <div className="d-flex align-items-center text-muted">
                                <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
                                <span className="small">No Disponible</span>
                                <Button
                                    onClick={ObtenerSaldoTimbres}
                                    variant="falcon-default"
                                    size="sm"
                                    className="ms-2"
                                    title="Reintentar"
                                >
                                    <FontAwesomeIcon icon="sync" />
                                </Button>
                            </div>
                        )}
                    </Col>
                </Row>
            </Card>


            <Form onSubmit={handleSubmit}>
                <Card className="factura-card mb-1 bg-white">
                    <Card.Body className="factura-card-body">
                        <Row>
                            <Col xl={6} className="col-divisor">
                                {/* Sección: Datos Fiscales */}
                                <DatosFiscalesReceptorFactura
                                    cargandoForm={obteniendoDetallesOrden}
                                    errors={errors}
                                    clearError={clearError}

                                    // Props de datos fiscales del cliente
                                    formData={formData}
                                    handleChange={handleChange}
                                    isForeignRFC={isForeignRFC}
                                    isGenericRFC={formData.vRFC?.toUpperCase().trim() === "XAXX010101000"}
                                    handleRFCChange={handleRFCChange}
                                />
                            </Col>
                            {/* Sección: Preferencias de Facturación */}
                            <PreferenciasFacturacion
                                // Props del formulario
                                formData={formData}
                                handleChange={handleChange}
                                clearError={clearError}
                                errors={errors}
                                cargandoForm={obteniendoDetallesOrden}

                                // Props de datos

                                minDate={minDate}
                                now={now}

                                // Componente DatePicker
                                GreetingsDateInput={GreetingsDateInput}

                                // Nueva prop para vRFC
                                vRFC={RFCSeleccionado}
                            />
                        </Row>
                        <hr className="my-3 text-muted" />
                        <Row>
                            <Col md={12}>
                                <Form.Check
                                    type="switch"
                                    id="switch-cfdi-relacionados"
                                    label={<span className="form-label-profesional text-dark">Incluir CFDI Relacionados</span>}
                                    className="ms-1"
                                    checked={incluirCfdiRelacionados}
                                    onChange={(e) => {
                                        setIncluirCfdiRelacionados(e.target.checked);
                                        if (!e.target.checked) {
                                            // Limpiar los valores para que no se envíen por accidente
                                            handleChange('cfdiRelacionados.TipoRelacion', '');
                                            handleChange('cfdiRelacionados.UUIDs', null);
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {incluirCfdiRelacionados && (
                    <CfdiRelacionados formData={formData} handleChange={handleChange} />
                )}

                <PagosOrden idOrden={parseInt(id) || 0} />

                <ProductosContainer
                    detallesOrdenCargados={detallesCargados}
                    ordenDetallesProductos={ordenDetallesProductos}
                    productosAgregados={productosAgregados}
                    setProductosAgregados={setProductosAgregados} />

                <Row className="justify-content-end mt-3">
                    {
                        facturandoTimbrando ?
                            <>
                                <Col className="col-auto">
                                    <Button
                                        variant="falcon-default"
                                        size="sm"
                                        className="d-sm-block me-2"
                                        disabled
                                    >
                                        <Spinner className="text-inline" animation="border" size="sm" variant="light" />&nbsp; Cargando...
                                    </Button>
                                </Col>
                            </>
                            :
                            <>
                                <Col className="col-auto d-flex align-items-center">
                                    {/* Botón "Facturar" */}
                                    <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="check"
                                        transform="shrink-2"
                                        type="submit"
                                        className="me-2" // Margen derecho para separar los botones
                                    >
                                        {/* Texto visible solo en pantallas grandes (xl) */}
                                        <span className=" ms-1">Facturar</span>
                                    </IconButton>

                                    {/* Botón "Cancelar" */}
                                    <IconButton
                                        onClick={() => {
                                            navigate(-1);
                                            // reset is gone, just navigate back
                                        }}
                                        icon="xmark"
                                        variant="falcon-danger"
                                        size="sm"
                                        transform="shrink-2"
                                    >
                                        {/* Texto visible solo en pantallas grandes (xl) */}
                                        <span className="ms-1">Cancelar</span>
                                    </IconButton>
                                </Col>
                            </>
                    }
                </Row>
            </Form>

            {/* Modal de error de timbrado */}
            <ModalErrorTimbrado
                show={showModalErrorTimbrado}
                onHide={() => setShowModalErrorTimbrado(false)}
                errorMessage={errorTimbradoMensaje}
                errorCode={errorTimbradoCodigo}
            />

        </>
    );
};

const FormularioFactura = () => {
    return (
        <ContabilidadLayout
            title={
                <><FontAwesomeIcon icon="file-invoice" className="me-2" />Formulario Facturación</>
            }
        >
            <FormularioFacturaContent />
        </ContabilidadLayout>
    );
};

export default FormularioFactura;




